var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71023 14.9654L19.6702 4.16527C19.8938 3.94491 20.2666 3.94491 20.4902 4.16527L21.8323 5.48776C22.0559 5.70813 22.0559 6.0755 21.8323 6.29586L9.10789 18.8347C8.88426 19.0551 8.53627 19.0551 8.31265 18.8347L2.14911 12.7611C1.9503 12.5651 1.9503 12.1978 2.14911 11.9774L3.51597 10.6549C3.7396 10.4346 4.11241 10.4346 4.31122 10.6549L8.70993 14.9651L8.71023 14.9654Z",
    fill: "#16BF5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmIcon);
export default __webpack_public_path__ + "static/media/confirm-icon.f7611a361f3619ae30479a0c75574cef.svg";
export { ForwardRef as ReactComponent };